package platform

actual fun createSmartContract(): SmartContract {
    TODO("Not yet implemented")
}
